<template>
  <div class="content">
    <div>
      <h3 class="title">What kind of car do you drive?</h3>
    </div>
    <div>
      <div class="notification is-info" v-show="message">{{ message }}</div>
      <div v-show="cars.length != 0 && selectedCar == 0">
        <v-select
          placeholder="Make"
          class="style-chooser"
          :options="uniqueMakes"
          label="make"
          v-model="makeSelect"
        ></v-select>
        <br />
        <v-select
          placeholder="Model"
          class="style-chooser"
          :options="cars.filter((x) => x.make == makeSelect)"
          label="model"
          v-model="selectedCar"
        ></v-select>
        <ul class="list">
          <!-- Keep this for loop for now in case I need in future
        <li class="list-item" v-for="car in cars" :key="car.id">
          <button class="button">{{ car.make }} {{ car.model }}</button>
        </li>
        --></ul>
      </div>
      <div v-show="selectedCar != 0">
        <br />
        <p>Nice! Lets get some more information about your...</p>
        <h3>{{ selectedCar.make }} {{ selectedCar.model }}</h3>
        <p><a @click="cancelCar()" class="small">(change car)</a></p>
        <p><a @click="saveCar()" class="small">(save car)</a></p>
        <router-link
          tag="button"
          class="button is-primary"
          :to="'/questions'"
          @click.native="saveCar()"
        >
          <span>Continue</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import ChooseCar from '@/components/choose-car.vue';
import { data, logger, userCar } from '../shared';

let uniqueMakes,
  selectedCar = [];

export default {
  name: 'Cars',
  data() {
    return {
      cars: [],
      message: '',
      makeSelect: '',
      selectedCar,
      userCar,
      uniqueMakes,
    };
  },
  /*components: {
    ChooseCar,
  },*/
  async created() {
    await this.loadCars();
    logger.info(`Load cars called`);
  },
  methods: {
    saveCar() {
      this.userCar = this.selectedCar;
      logger.info(`Save car called \n` + JSON.stringify(userCar, null, '\n '));
      this.message = JSON.stringify(userCar, null, '\n ');
    },
    cancelCar() {
      this.selectedCar = '';
    },
    async loadCars() {
      this.cars = [];
      this.message = 'Grabbing a list of cars, one sec...';
      this.cars = await data.getAPICars();
      let makes = this.cars.map((car) => car.make); // Extracts all makes
      this.uniqueMakes = [...new Set(makes)]; // Makes without duplicates
      this.uniqueMakes = this.uniqueMakes.sort();
      this.message = '';
    },
  },
};
</script>
